import { LiveKitCredentialsInterface } from "@api/models/interfaces/web-conference/LiveKitCredentialsInterface";

export class LiveKitCredentials implements LiveKitCredentialsInterface {
    jwt: string;
    serverUrl: string;
    userId: number;

    constructor(data: LiveKitCredentialsInterface) {
        Object.assign(this, data);
    }
}
